import axios from "axios";
import { get } from "lodash";

const axiosInstance = axios.create();
axiosInstance.defaults.baseURL = process.env.REACT_APP_URL || 'http://127.0.0.1:8000/';

axiosInstance.interceptors.request.use(
  (axiosConfig) => {
    const authToken = localStorage.getItem("authToken");
    if (authToken) {
      axiosConfig.headers.Authorization = `Bearer ${authToken}`;
      // axiosConfig.headers.Authorization = `${authToken}`;
    }
    if (axiosConfig?.rawRequest) {
      // header for file_upload, video/audio will handle here i.e raw requests
      axiosConfig.headers["Content-Type"] = "multipart/form-data";
    } else {
      axiosConfig.headers["Content-Type"] = "application/json";
    }
    // axiosConfig.headers["Content-Type"] = "application/json";
    return axiosConfig;
  },
  (error) => {
    Promise.reject(error);
  }
);

const ROLE_REFUSALS = ["PERMISSION_DENIED", "READ_ONLY_ROLE"];

/*
  Response Interceptor
  Responsibilities:
  1- If api sends 401 token then send user to login page
*/
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const status = get(error, "response.status", "");
    const requestUrl = get(error, "config.url", "");
    const isAuthRequest = typeof requestUrl === "string" && requestUrl.includes("/auth/login");
    const errorCode = get(error, "response.data.errorCode", null);
    if (status === 403 && ROLE_REFUSALS.includes(errorCode)) {
      error.message = get(error, "response.data.message", null) || "You do not have access to this.";
      return Promise.reject(error);
    }
    if (!isAuthRequest && (status === 401 || status === 403)) {
      localStorage.clear();
      window.location.reload();
      return;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
